import Index from '@tunnel-components/@sharded/masque/container'

/**
 * @export Container
 */

export default Index



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/masque/index.ts